import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
//style
import styles from 'src/asset/scss/style/market.detail.module.scss';
//bottomSheet
import { BottomSheet } from 'react-spring-bottom-sheet';
//import 'react-spring-bottom-sheet/dist/style.css';
import 'src/asset/scss/plugin/bottomsheet/style.scss';
import 'src/asset/scss/plugin/bottomsheet/bottomsheet.scss';
//hook
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import useComnStore from 'src/webapp/stores/comn.store';
import usePartnerStore from 'src/webapp/stores/partner.store';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function MarketSuccess(props) {
    const { isOpen, marketItemLAPI } = props;//props
    const formRef = useRef();
    const isLock = useRef(false);
    const params = useParams();
    //hook
    const { axiosPostHandler } = useAxiosHook();
    //store
    const { setMessage } = useComnStore();
    const { partner } = usePartnerStore();
    
    /* ==================== 거래완료 ==================== */
    const marketItemContractSuccessAPI= async(type) => {//type - 1.구매희망자선택 2.구매희망자선택안함
        if (isLock.current) {return;}
        isLock.current = true;
        //input Radio Checked상태인DOM을 선택하는 변수
        const selected = formRef.current.querySelector('input[type="radio"]:checked');
        if (selected || type == 2) {
            let DATA = {};
            if(type == 1){
                //해당DOM의 인덱스값 얻기
                const index = parseInt(selected.dataset.index);
                //선택한 구매희망자 값
                const selectedData = ContractList[index];
                DATA = {SEQ_NO: params.seq, TYPE:selectedData.TYPE, USER_CD: selectedData.USER_CD, PARTNER_CD: partner.COMN_CD};
            }
            if(type == 2){
                DATA = {SEQ_NO: params.seq, PARTNER_CD: partner.COMN_CD};
            }
            const result = await axiosPostHandler(`marketItemContractSuccessForJson.do`, DATA);
            setTimeout(() => {isLock.current = false;}, 300)
            if(!result) {setMessage({ type: 2, message: `잠시 후 다시 시도해주세요.` });return;}
            if(result.message == "SUCCESS"){
                setMessage({ type: 1, message: `거래완료 처리가 완료되었습니다.` });
                props.onDismiss("success", false);
                marketItemLAPI();//디테일 데이터 갱신
            }
        }else {
            setTimeout(() => {isLock.current = false;}, 300)
            return alert("선택된 항목이 없습니다.");
        }
    }
    /* ==================== 거래완료 ==================== */
    /* ==================== 구매희망자리스트 ==================== */
    const [ ContractList, setContractList ] = useState([]);
        const marketItemContractListAPI = async() => {
        const DATA = { SEQ_NO: params.seq };
        const result = await axiosPostHandler(`marketItemContractListForJson.do`, DATA);
        if(!result) {return;}
        if(result.message == "SUCCESS"){
            setContractList(result.data);
        }
    }
    /* ==================== 구매희망자리스트 ==================== */
    return (
        <BottomSheet open={isOpen} onDismiss={(e) => { props.onDismiss("success", false) }} className={'bottomsheetContainer'}
            onSpringStart={async (event) => {
				if(event.type === 'OPEN') { marketItemContractListAPI(); }
			}}
            header={
                <>
                <button className={'bottomsheetDissmissButton'} onClick={(e) => props.onDismiss("success", false)}><FontAwesomeIcon icon="fa-light fa-xmark" /></button>
                <div style={{marginBottom:'3.75rem'}} className={'bottomsheetHeaderContainer'}>
                    <h1>구매자 선택</h1>
                </div>
                </>
            }
            footer={
				<div className={styles.bottomsheetMarketSuccessBtnArea}>
                    <button className={styles.onChoice} disabled={false} onClick={() => marketItemContractSuccessAPI(1)}>확인</button>
                    <button onClick={() => marketItemContractSuccessAPI(2)}>선택하지 않을래요</button>
                </div>
            }
            snapPoints={({ maxHeight }) => maxHeight}
            skipInitialTransition={false} scrollLocking={true} expandOnContentDrag={true}>
            <Element tag={`div`} className={styles.bottomsheetMarketSuccessButtonContainer} propRef={formRef}>
                <Element tag={`ul`}>
                    {ContractList.map((item, i) =>
                        <li key={i}>
                            <div className={'radio'}><input type="radio" id={`radio-${i}`} defaultChecked={i == 0 ? true : false} name={`radio`} data-index={i} /><label htmlFor={`radio-${i}`} className="radio-label"></label></div>
                            <div className={styles.imgArea}></div>
                            <div className={styles.vendorInfo}>
                                <h1><span>{item?.USER_NAME ? item?.USER_NAME : null}</span><small>{item?.TYPE == 1 ? "파트너" : item?.TYPE == 2 ? "멤버" : null}</small></h1>
                                <p>{item?.REG_DT ? item?.REG_DT : null }</p>
                            </div>
                        </li>
                    )}
                </Element>
            </Element>
        </BottomSheet>
    )
}